import React from 'react'

import { useLockableComponent } from '~/store/hooks/soap'
import type { FeatureElements } from '~/types'

import AddendumsSection from '../wrap-up/addendum/AddendumsSection'
import MedicalDischargeNotesWidgetLocked from './MedicalDischargeNotesWidgetLocked'
import MedicalDischargeNotesUnlockedWidget from './MedicalDischargeNotesWidgetUnlocked'

export interface MedicalDischargeNotesWidgetProps {
  defaultDischargeNotesTemplateId?: string
  defaultMedicalNotesTemplateId?: string
  hideElements?: FeatureElements[]
}

const MedicalDischargeNotesWidget = ({
  hideElements,
  defaultDischargeNotesTemplateId,
  defaultMedicalNotesTemplateId,
}: MedicalDischargeNotesWidgetProps) => {
  const MedicalDischargeNotesWidgetComponent = useLockableComponent(
    MedicalDischargeNotesUnlockedWidget,
    MedicalDischargeNotesWidgetLocked,
  )

  return (
    <>
      <MedicalDischargeNotesWidgetComponent
        defaultDischargeNotesTemplateId={defaultDischargeNotesTemplateId}
        defaultMedicalNotesTemplateId={defaultMedicalNotesTemplateId}
        hideElements={hideElements}
      />
      <AddendumsSection />
    </>
  )
}

export default MedicalDischargeNotesWidget
